/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gdpr_Anonymise_ConfirmInputs */

const cs_gdpr_anonymise_confirm = /** @type {(inputs: Gdpr_Anonymise_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nevratně anonymizovat`)
};

const en_gdpr_anonymise_confirm = /** @type {(inputs: Gdpr_Anonymise_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anonymise irreversibly`)
};

/**
* | output |
* | --- |
* | "Anonymise irreversibly" |
*
* @param {Gdpr_Anonymise_ConfirmInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gdpr_anonymise_confirm = /** @type {((inputs?: Gdpr_Anonymise_ConfirmInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gdpr_Anonymise_ConfirmInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gdpr_anonymise_confirm(inputs)
	return cs_gdpr_anonymise_confirm(inputs)
});